import { apiUri } from '../../constants/Constants';
import { client } from '../axios/axiosClient';
import { Building } from '../types/building.interface';

const getBuildings = async () => {
  const response = await client.get<Building[]>(apiUri.buildingsList, { withCredentials: true });
  return response.data;
};

export default getBuildings;
